
export default {
  name: 'Table',
  props: {
    items: {
      type: Array,
      default() {
        return [{ technicalInformation: {} }]
      },
    },
    logos: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      id: 'car-details',
    }
  },
}
